import { render } from "./App.vue?vue&type=template&id=53f81bf0&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script